import React from 'react';

import { AddressDetails } from './Applications';
import { formatCurrency } from '../../../lib/utils/formatters';
import { fromISO } from '../../../lib/utils/datetime_formatters';

export default function EntityInfo({ props }) {
  const { entity, type } = props;

  return (
    <div className="font-avenir-book capitalize">
      <div className="mb-6">
        <p className="font-avenir-black tracking-wide text-navy-blue text-lg">
          Info
        </p>
        <p>
          Status:{' '}
          {type === 'company' ? entity?.underwriting_status : entity?.status}
        </p>
        <p>
          Tier:{' '}
          {entity?.tier.includes('_')
            ? entity?.tier.replace('_', ' ')
            : entity?.tier}
        </p>
        <p>Created: {fromISO(entity?.created_at).toLocaleString()}</p>
        {type === 'company' && (
          <p>
            Next Credit Refresh Date:{' '}
            {entity?.next_credit_refresh_on
              ? fromISO(entity?.next_credit_refresh_on).toLocaleString()
              : 'N/A'}
          </p>
        )}
        <p>
          Last Modified Date: {fromISO(entity?.updated_at).toLocaleString()}
        </p>
      </div>
      {type === 'company' && (
        <div>
          <p className="font-avenir-black tracking-wide text-navy-blue text-lg">
            Company Info
          </p>
          <div>
            <p className="ph-no-capture">EIN: {entity?.ein}</p>
            <p>
              Gross Annual Revenue: {formatCurrency(entity?.gross_annual_revenue)}
            </p>
            <p>Number of Beneficial Owners: {entity?.owner_count}</p>
            <p>Company OFAC Status: {entity?.ofac_status}</p>
            <div className="ph-no-capture">
              <AddressDetails type="company" appAddress={entity?.address} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
